export default __webpack_public_path__ + "static/media/elevate-red-poster-2.1dbf8409.jpg";